import {
  UilBooks,
  UilInvoice,
  UilRefresh,
  UilUsersAlt
} from '@iconscout/react-unicons';

export const buildProductionStats = stats => [
  {
    title: 'Projects',
    count: stats?.totalProjects ?? 0,
    icon: UilBooks,
    iconColor: 'primary',
    subtitle: 'Awaiting processing'
  },
  {
    title: 'Active',
    count: stats?.activeTasks ?? 0,
    icon: UilUsersAlt,
    iconColor: 'warning',
    subtitle: 'Tasks in execution'
  },
  {
    title: 'Completed',
    count: stats?.completedTasks ?? 0,
    icon: UilInvoice,
    iconColor: 'success',
    subtitle: 'Finished tasks'
  },
  {
    title: 'Pending',
    count: stats?.pendingTasks ?? 0,
    icon: UilRefresh,
    iconColor: 'danger',
    subtitle: 'Waiting to start'
  }
];
